var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import useOnnitContext from "../../hooks/useOnnitContext";
import Box from "onnit-ui/lib/box/Box";
import Text from "onnit-ui/lib/text/Text";
import { getSizeText } from "./sizes";
function getColorLabel(product) {
    var _a;
    if (product.meta["a-color1"] === product.meta["a-color2"]) {
        return (_a = product.meta["a-color1"]) !== null && _a !== void 0 ? _a : "";
    }
    return "".concat(product.meta["a-color1"], " / ").concat(product.meta["a-color2"]);
}
var OOSSvg = function (props) {
    return (React.createElement("svg", __assign({ width: "100%", height: "100%", viewBox: "0 0 100 100", preserveAspectRatio: "none" }, props),
        React.createElement("line", { x1: "0", y1: "0", x2: "100%", y2: "100%", stroke: "#666", strokeWidth: "2px" }),
        React.createElement("line", { x1: "0", y1: "100%", x2: "100%", y2: "0", stroke: "#666", strokeWidth: "2px" })));
};
function VariantSelector(_a) {
    var _b, _c, _d, _e;
    var containerProduct = _a.containerProduct, selectedColorVariant = _a.selectedColorVariant, selectedSizeVariant = _a.selectedSizeVariant, setColorVariant = _a.setColorVariant, setSizeVariant = _a.setSizeVariant, onChange = _a.onChange, rest = __rest(_a, ["containerProduct", "selectedColorVariant", "selectedSizeVariant", "setColorVariant", "setSizeVariant", "onChange"]);
    var onnitContext = useOnnitContext();
    if (!onnitContext || !selectedColorVariant || !selectedSizeVariant) {
        return null;
    }
    var isOnSale = selectedSizeVariant.sale_discount_ratio > 0;
    var saleText = isOnSale ? "".concat((selectedSizeVariant.sale_discount_ratio * 100).toFixed(), "% off") : "";
    return (React.createElement(Box, __assign({}, rest),
        selectedSizeVariant.sale_discount_ratio === 1 ? (React.createElement(Box, { mb: 4 },
            React.createElement(Text, { display: "inline-block", fontWeight: "bold", fontSize: 4 }, "FREE"))) : (React.createElement(Box, { mb: 4 },
            isOnSale && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "sr-only" }, "Normally,"),
                React.createElement(Text, { fontSize: 4, display: "inline-block", textDecoration: "line-through", color: "grays.4", mr: 2 }, selectedSizeVariant.price_msrp),
                React.createElement("span", { className: "sr-only" }, "Your price today,"))),
            React.createElement(Text, { display: "inline-block", fontWeight: "heavy", fontSize: 4 }, selectedSizeVariant.price),
            isOnSale && (React.createElement(Text, { display: "inline-block", fontWeight: "bold", color: "grays.4", fontSize: 4, ml: 2 }, saleText)))),
        Number((_b = containerProduct === null || containerProduct === void 0 ? void 0 : containerProduct.children) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement(Box, { mb: 3 },
            React.createElement(Box, { display: "flex", mb: 2, tabIndex: -1 },
                React.createElement(Text, { fontWeight: "bold", mr: 2 }, "Color:"),
                selectedColorVariant && React.createElement(Text, null, getColorLabel(selectedColorVariant))),
            React.createElement(Box, { display: "flex", flexWrap: "wrap" }, (_c = containerProduct.children) === null || _c === void 0 ? void 0 : _c.map(function (variant) {
                return (React.createElement(Box, { as: "button", "aria-label": "Color ".concat(variant.meta["a-color1"], ", ").concat(variant.meta["a-color2"]), "aria-pressed": variant === selectedColorVariant, key: variant.id, bg: "grays.1", overflow: "hidden", mr: 1, tabIndex: 0, onClick: function () { return setColorVariant(variant); }, width: "58px", height: "80px", style: {
                        backgroundImage: "url(".concat(onnitContext === null || onnitContext === void 0 ? void 0 : onnitContext.url.cdn.static_images, "/authority/").concat(variant.meta["authority-id"], ".png?w=100)"),
                        backgroundPosition: "center top",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        cursor: "pointer",
                        border: "none",
                        boxShadow: variant === selectedColorVariant
                            ? "inset 0 0 0 2px black"
                            : "none",
                    } },
                    React.createElement("span", { className: "sr-only" },
                        "Select color ",
                        getColorLabel(variant))));
            })))),
        selectedColorVariant && Number((_d = selectedColorVariant === null || selectedColorVariant === void 0 ? void 0 : selectedColorVariant.children) === null || _d === void 0 ? void 0 : _d.length) > 0 && (React.createElement(Box, null,
            React.createElement(Box, { display: "flex", mb: 2, tabIndex: -1 },
                React.createElement(Text, { fontWeight: "bold", mr: 2 }, "Size:"),
                selectedSizeVariant && React.createElement(Text, null, selectedSizeVariant.meta["a-size"])),
            React.createElement(Box, { display: "flex", flexWrap: "wrap" }, (_e = selectedColorVariant.children) === null || _e === void 0 ? void 0 : _e.map(function (sizeVariant) {
                return (React.createElement("button", { key: sizeVariant.id, tabIndex: 0, onClick: function () { return onChange(sizeVariant); }, "aria-pressed": sizeVariant === selectedSizeVariant, style: {
                        textAlign: "center",
                        paddingLeft: 12,
                        paddingRight: 12,
                        paddingTop: 14,
                        paddingBottom: 14,
                        border: "none",
                        position: "relative",
                        marginRight: 8,
                        marginBottom: 8,
                        minWidth: 46,
                        cursor: "pointer",
                        backgroundColor: sizeVariant === selectedSizeVariant
                            ? sizeVariant.in_stock
                                ? "black"
                                : "#e4e4e4"
                            : "transparent",
                        boxShadow: sizeVariant === selectedSizeVariant
                            ? "none"
                            : "inset 0 0 0 1px #666",
                    } },
                    React.createElement(Text, { fontSize: 1, color: sizeVariant.in_stock
                            ? sizeVariant === selectedSizeVariant
                                ? "white"
                                : "black"
                            : "#666" },
                        React.createElement("span", { className: "sr-only" }, "Size ".concat(sizeVariant.meta["a-size"], " ").concat(!sizeVariant.in_stock ? ", out of stock" : "")),
                        React.createElement("span", { "aria-hidden": true }, getSizeText(sizeVariant.meta["a-size"]))),
                    !sizeVariant.in_stock && (React.createElement(OOSSvg, { style: { position: "absolute", top: 0, left: 0 } }))));
            }))))));
}
export default VariantSelector;
//# sourceMappingURL=VariantSelector.js.map